import { render, staticRenderFns } from "./InspectionDetailHeader.vue?vue&type=template&id=f4af5adc&scoped=true&"
import script from "./InspectionDetailHeader.vue?vue&type=script&lang=js&"
export * from "./InspectionDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDetailHeader.vue?vue&type=style&index=0&id=f4af5adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4af5adc",
  null
  
)

export default component.exports